// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function formatAmount(value) {
  return I18n.currencyFormat(undefined, "EUR", 0, 2, value);
}

function formatePoints(shortOpt, points) {
  let short = shortOpt !== undefined ? shortOpt : false;
  let unit = short ? (
      I18n.isPlural(points) ? I18n.t("pts") : I18n.t("pt")
    ) : I18n.t(I18n.isPlural(points) ? "points" : "point");
  return I18n.decimalFormat(undefined, undefined, undefined, undefined, points) + I18n.narrowNoBreakSpace + unit;
}

function stripEmptyString(value) {
  return Stdlib_Option.flatMap(value, StringHelpers.stripEmptyString);
}

function makeReward(kind, discountEvolutiveRate, discountUnit, discountValue, offeredProductLabel) {
  if (kind === "DISCOUNT") {
    if (discountEvolutiveRate !== undefined) {
      return {
        TAG: "Evolutive",
        euros: discountEvolutiveRate.euros,
        points: discountEvolutiveRate.points
      };
    } else if (discountUnit !== undefined) {
      if (discountUnit === "PERCENTAGE") {
        if (discountValue !== undefined) {
          return {
            TAG: "Percent",
            percent: discountValue
          };
        } else {
          return;
        }
      } else if (discountUnit === "EUR" && discountValue !== undefined) {
        return {
          TAG: "Fixed",
          euros: discountValue
        };
      } else {
        return;
      }
    } else {
      return;
    }
  } else {
    return {
      TAG: "Offered",
      productLabel: Stdlib_Option.flatMap(offeredProductLabel, StringHelpers.stripEmptyString)
    };
  }
}

function formateRewardTitle(reward) {
  switch (reward.TAG) {
    case "Offered" :
      return I18n.t("1 offered product");
    case "Fixed" :
      return I18n.template(I18n.t("Voucher of {{amount}}"), {
        amount: formatAmount(reward.euros)
      }, undefined);
    case "Evolutive" :
      return I18n.template(I18n.t("Voucher of {{amount}} / {{points}}"), {
        amount: formatAmount(reward.euros),
        points: formatePoints(true, reward.points)
      }, undefined);
    case "Percent" :
      return I18n.template(I18n.t("{{percent}} discount"), {
        percent: I18n.percentFormat(undefined, undefined, 2, reward.percent / 100)
      }, undefined);
  }
}

function formateRewardDescription(reward) {
  if (reward.TAG === "Offered") {
    return reward.productLabel;
  } else {
    return I18n.t("Immediate discount on the next cart");
  }
}

function formateRewardPointsCost(points) {
  return I18n.template(I18n.t("From {{points}}"), {
    points: formatePoints(undefined, points)
  }, undefined);
}

function formateRewardVisitsCooldown(visits) {
  return I18n.template(I18n.t(I18n.isPlural(visits) ? "{{visits}} checkout visits" : "{{visits}} checkout visit"), {
    visits: visits.toString()
  }, undefined);
}

function unlockProgress(points, pointsToUnlock) {
  if (pointsToUnlock <= 0) {
    return 1;
  } else {
    return Math.min(Math.max(points / pointsToUnlock, 0), 1);
  }
}

function isAddonActivated(shops, shopId) {
  return shops.some(shop => {
    if (shop.id === shopId) {
      return shop.loyaltyAddonActivated;
    } else {
      return false;
    }
  });
}

function isAddonActivatedInAny(shops) {
  return shops.some(param => param.loyaltyAddonActivated);
}

function useAddonActivated(shopId) {
  return isAddonActivated(Auth.useShops(), shopId);
}

function fromRaw(value) {
  if (value === "GAIN") {
    return "Gain";
  } else if (value === "LOSS") {
    return "Loss";
  } else {
    return "Reset";
  }
}

function toLabel(value) {
  switch (value) {
    case "Gain" :
      return I18n.t("loyalty.activity_kind.gain");
    case "Loss" :
      return I18n.t("loyalty.activity_kind.loss");
    case "Reset" :
      return I18n.t("loyalty.activity_kind.reset");
  }
}

function toSign(value) {
  switch (value) {
    case "Gain" :
      return "+";
    case "Loss" :
      return "-";
    case "Reset" :
      return "=";
  }
}

function toColor(value) {
  switch (value) {
    case "Gain" :
      return "#009F5D";
    case "Loss" :
      return "#D92964";
    case "Reset" :
      return "#25243A";
  }
}

function toColorSet(value) {
  switch (value) {
    case "Gain" :
      return {
        bgColor: "#CEFDE0",
        textColor: "#00653E",
        borderColor: "#66EFAC"
      };
    case "Loss" :
      return {
        bgColor: "#FCE7F1",
        textColor: "#821938",
        borderColor: "#F8A9CC"
      };
    case "Reset" :
      return {
        bgColor: "#E7E7EE",
        textColor: "#25243A",
        borderColor: "#A2A1B0"
      };
  }
}

let make = React.memo(props => {
  let kind = props.kind;
  let match = toColorSet(kind);
  return JsxRuntime.jsx(Badge.make, {
    children: Stdlib_Option.getOr(props.label, toLabel(kind)),
    size: "medium",
    borderColor: match.borderColor,
    backgroundColor: match.bgColor,
    foregroundColor: match.textColor
  });
});

let Badge$1 = {
  toColorSet: toColorSet,
  make: make
};

let LoyaltyActivityKind = {
  fromRaw: fromRaw,
  toLabel: toLabel,
  toSign: toSign,
  toColor: toColor,
  Badge: Badge$1
};

function make$1(kind, points, hasSale, hasReward) {
  let match = hasSale || hasReward;
  switch (kind) {
    case "Gain" :
      if (points < 0) {
        return "Return";
      } else if (hasSale) {
        return "Purchase";
      } else if (match) {
        return {
          TAG: "Kind",
          _0: kind
        };
      } else {
        return "WelcomePoints";
      }
    case "Loss" :
      if (match) {
        return "RewardUsed";
      } else {
        return {
          TAG: "Kind",
          _0: kind
        };
      }
    case "Reset" :
      if (match) {
        return "RewardReset";
      } else {
        return "Manual";
      }
  }
}

function toLabel$1(value) {
  if (typeof value === "object") {
    return toLabel(value._0);
  }
  switch (value) {
    case "Purchase" :
      return I18n.t("loyalty.activity_reason.purchase");
    case "Return" :
      return I18n.t("loyalty.activity_reason.return");
    case "WelcomePoints" :
      return I18n.t("loyalty.activity_reason.welcome_points");
    case "RewardUsed" :
      return I18n.t("loyalty.activity_reason.reward_used");
    case "RewardReset" :
      return I18n.t("loyalty.activity_reason.reward_reset");
    case "Manual" :
      return I18n.t("loyalty.activity_reason.manual");
  }
}

let LoyaltyActivityReason = {
  make: make$1,
  toLabel: toLabel$1
};

function formateActivityPoints(kind, points) {
  return toSign(kind) + " " + formatePoints(true, points);
}

export {
  formatAmount,
  formatePoints,
  stripEmptyString,
  makeReward,
  formateRewardTitle,
  formateRewardDescription,
  formateRewardPointsCost,
  formateRewardVisitsCooldown,
  unlockProgress,
  isAddonActivated,
  isAddonActivatedInAny,
  useAddonActivated,
  LoyaltyActivityKind,
  LoyaltyActivityReason,
  formateActivityPoints,
}
/* make Not a pure module */
